import { render } from "./SessionEditDialog.vue?vue&type=template&id=27397982&scoped=true"
import script from "./SessionEditDialog.vue?vue&type=script&lang=js"
export * from "./SessionEditDialog.vue?vue&type=script&lang=js"

import "./SessionEditDialog.vue?vue&type=style&index=0&id=27397982&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27397982"]])

export default __exports__